import { GroupDownloadDto } from "collaboration-service";
import { ImgSelect } from "imaginarity-react-ui";
import * as _ from "lodash";
import * as React from "react";

interface GroupSelectProps<IsClearable extends boolean = false> {
    groups: GroupDownloadDto[];
    onChange?: IsClearable extends true ? ((s?: GroupDownloadDto) => void) : ((s: GroupDownloadDto) => void);
    value?: GroupDownloadDto;
    isClearable?: IsClearable;
    createLabel?: (group: GroupDownloadDto) => string;
    disabled?: boolean;
}


const GroupSelect = <IsClearable extends boolean = false>(props: GroupSelectProps<IsClearable>) => {

    const groups = _.map(props.groups, g => ({ label: props.createLabel ? props.createLabel(g) : g.name, value: g }));
    const innerval = _.find(groups, g => g.value.id === props.value?.id);

    const chg = (val: { label: string, value: GroupDownloadDto } | null) => {
        if (props.onChange) {
            if (props.isClearable)
                (props.onChange as any)(val?.value);
            else if (val)
                props.onChange(val.value);
        }
    }
    return (
        <ImgSelect
            value={innerval}
            options={groups}
            onChange={chg}
            isClearable={props.isClearable}
            isDisabled={props.disabled}
        />
    )
}

export default GroupSelect;